export const SMARTPAK = 1;
export const SUPPLY = 2;
export const PORTIONPAK = 3;